import * as Yup from 'yup';

const SIGN_UP_SCHEMA = Yup.object().shape({
	first_name: Yup.string().required('This field is required'),
	last_name: Yup.string().required('This field is required'),
	organization: Yup.string().required('This field is required'),
	email: Yup.string().email('Invalid email').required('This field is required'),
	password1: Yup.string().required('This field is required'),
	password2: Yup.string()
		.oneOf([Yup.ref('password1'), null], 'Passwords do not match!')
		.required('This field is required'),
	street: Yup.string().required('This field is required'),
	city: Yup.string().required('This field is required'),
	state: Yup.string().required('This field is required'),
	zipcode: Yup.string().required('This field is required')
});

export default SIGN_UP_SCHEMA;
